export default __webpack_public_path__ + "static/media/independence-day-appbar-tile.d3e00af3.png";